import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  type CanActivate,
  Router,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { CognitoService } from './cognito-service';
import { RoleGuardService } from './role-guard.service';

@Injectable()
export class AdminGuardService implements CanActivate {
  constructor(
    private router: Router,
    private cognitoService: CognitoService,
    private roleGuardService: RoleGuardService,
  ) {}

  private getResolvedUrl(route: ActivatedRouteSnapshot): string {
    return route.pathFromRoot
      .map((v) => v.url.map((segment) => segment.toString()).join('/'))
      .join('/');
  }

  canActivate(
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.cognitoService.isAdmin() || this.roleGuardService.hasPermission('users:View')) return true;

    this.router.navigate(['/dashboard']);

    return false;
  }
}
